document.addEventListener("DOMContentLoaded", (event) => {
  // *** Check if bundle page
  if (window.location.href.indexOf("bundle") > -1) {
    // *** Adding container class to bundle app body
    var bundleBody = document.querySelector("#bundle-builder-app--bundle--root");
    bundleBody.classList.add("container");
  
    // *** Adding "Vis flere" button to each section
    function addShowMoreButtons() {
      var bundleSections = document.querySelectorAll(".TemplateList-module__template-list-container");

      if (bundleSections.length > 0) {
        bundleSections.forEach((section) => {
          if (!section.querySelector("#showMoreProducts")) {
            var showMoreButton = document.createElement("button");
            showMoreButton.id = "showMoreProducts";
            showMoreButton.textContent = "Vis flere 🞃";

            section.appendChild(showMoreButton)
          }
        })

        clearInterval(intervalId);
        setTimeout(function() {
          toggleHideShowProducts();
        }, 250)
      }
    }

    var intervalId = setInterval(addShowMoreButtons, 500);

    // *** Add toggle to show and hide products in different sections
    function toggleHideShowProducts() {
      const containers = document.querySelectorAll(".TemplateList-module__template-list-container");

      containers.forEach(container => {
        const productCards = container.querySelectorAll('[data-product-id]');
        const showMoreButton = container.querySelector("#showMoreProducts");
    
        if (productCards.length > 1) {
          for (let i = 1; i < productCards.length; i++) {
            productCards[i].style.display = "none";
          }
        }
    
        showMoreButton.addEventListener("click", function() {
          const isExpanded = this.getAttribute("data-expanded") === "true";
    
          if (isExpanded) {
            for (let i = 4; i < productCards.length; i++) {
              productCards[i].style.display = "none";
            }
            this.textContent = "Vis flere 🞃";
            this.setAttribute("data-expanded", "false");
          } else {
            // Show all products and change button text to "Vis færre"
            for (let i = 4; i < productCards.length; i++) {
              productCards[i].style.display = "";
            }
            this.textContent = "Vis færre";
            this.setAttribute("data-expanded", "true");
          }
        });
      });
    }
  } // --- End if bundle page
})